const STORAGE_PREFIX = "mozzoapp:branch-tables:";

export const BRANCH_TABLES_UPDATED_EVENT = "mozzoapp:branch-tables-updated";

export const buildBranchTablesStorageKey = (branchId) =>
  `${STORAGE_PREFIX}${branchId || "default"}`;

const normalizeBranchTables = (tables) =>
  Array.isArray(tables)
    ? tables.map((table) => ({
        id: table?.id || "",
        branchId: table?.branchId || table?.branch_id || "",
        tableNumber: Number(table?.tableNumber || table?.table_number || 0),
        label: table?.label || "",
        active: table?.active !== false,
        createdAt: table?.createdAt || table?.created_at || null,
        qr: table?.qr
          ? {
              id: table.qr.id || "",
              token: table.qr.token || table.qr.qr_token || "",
              sizePx: Number(table.qr.sizePx || table.qr.size_px || 128),
              createdAt: table.qr.createdAt || table.qr.created_at || null,
              accessEnabledUntil:
                table.qr.accessEnabledUntil ||
                table.qr.access_enabled_until ||
                null,
              lastAccessEnabledAt:
                table.qr.lastAccessEnabledAt ||
                table.qr.last_access_enabled_at ||
                null,
            }
          : null,
      }))
    : [];

export const getBranchTablesSnapshot = (branchId) => {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const rawValue = window.localStorage.getItem(
      buildBranchTablesStorageKey(branchId)
    );

    if (!rawValue) {
      return [];
    }

    return normalizeBranchTables(JSON.parse(rawValue));
  } catch (error) {
    return [];
  }
};

export const saveBranchTablesSnapshot = (branchId, tables) => {
  const normalizedTables = normalizeBranchTables(tables);

  if (typeof window === "undefined") {
    return normalizedTables;
  }

  window.localStorage.setItem(
    buildBranchTablesStorageKey(branchId),
    JSON.stringify(normalizedTables)
  );
  window.dispatchEvent(
    new CustomEvent(BRANCH_TABLES_UPDATED_EVENT, {
      detail: {
        branchId: branchId || "default",
        tables: normalizedTables,
      },
    })
  );

  return normalizedTables;
};
